import Service from './service'
import Subcategory from './subcategory'
import { useCollapse } from '../contextProviders/CollapseContext';
import Status from './StateIconFromObject';
import { ICategory } from '../../rz-status_models';

export default function({category, hideState = false}: {category: ICategory, hideState: boolean})  {
  const { expanded, toggle} = useCollapse();
  const isExpanded = expanded.includes(category.id);
  
  return <li className={"block collapsible"+ (isExpanded ? " open" : "")}>
    <button onClick={() => toggle(category.id)} aria-expanded={isExpanded ? "true" : "false"} aria-controls={`category_${category.id}`} aria-label={`Serviceübersicht zu "${category.name}" ${isExpanded ? "zuklappen" : "aufklappen"}`} >
      <span className="icon indicator"/><span className="overflow">{category.name}</span> {!isExpanded && !hideState && <Status item={category} counter/>}
    </button>

    <div id={`category_${category.id}`} className="details collapsible-content">
      {(category.services && category.services.length > 0)? <ul aria-label={`Services für ${category.name}`}>
        {category.services.map(s => <Service key={s.id} service={s} hideState={hideState}/>)}
      </ul> : ""}

      {(category.categories && category.categories.length > 0)? <ul aria-label={`Unterkategorien für ${category.name}`}>
        {category.categories.map(s => <Subcategory key={s.id} sub={s} hideState={hideState}/>)}
      </ul> : ""}
    </div>
  </li>
}